// extracted by mini-css-extract-plugin
module.exports = {"footerLinksContainer":"styles_footerLinksContainer__1LUyp","footerLogo":"styles_footerLogo__2W97Q","footerLinks":"styles_footerLinks__2mixD","version":"styles_version__13rG5"};